<!--  <iframe id="react-iframe" src="../../../assets/dt/index.html" style="width: 100%; height: 100%"></iframe>
 -->
<!-- <h1>DT Component</h1>
<iframe [src]="dtApp" frameborder="0" width="100%" height="800"></iframe> -->
<dt-comp></dt-comp>
